// MODULES //
import { Injectable } from "@angular/core";

// OTHERS //
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FingerprintService {
  private fingerprint: string = "";
  private fingerprintReady = new BehaviorSubject<boolean>(false);

  constructor() {
    this.initializeFingerprint();
  }

  /**
   * Initialize the fingerprint and set the fingerprintReady subject to true
   */
  private async initializeFingerprint() {
    try {
      // Initialize the fingerprint
      const fp = await FingerprintJS.load();
      // Get the fingerprint
      const result = await fp.get();
      // Set the fingerprint
      this.fingerprint = result.visitorId;
      // Set the fingerprintReady subject to true
      this.fingerprintReady.next(true);
    } catch (error) {
      console.error("Error generating fingerprint:", error);
    }
  }

  /**
   * Get the fingerprint
   * @returns {Promise<string>} The fingerprint
   */
  public async getFingerprint(): Promise<string> {
    // Check if the fingerprint is ready
    if (!this.fingerprintReady.value) {
      // Wait for the fingerprint to be ready
      await new Promise<void>((resolve) => {
        // Subscribe to the fingerprintReady subject
        const subscription = this.fingerprintReady.subscribe((isReady) => {
          // If the fingerprint is ready, unsubscribe from the subject and resolve the promise
          if (isReady) {
            subscription.unsubscribe();
            resolve();
          }
        });
      });
    }
    // Return the fingerprint
    return this.fingerprint;
  }
}
